import React from 'react';
import PropTypes from 'prop-types';

AtomItemPagination.defaultProps = {
  className: 'ItemPagination',
  onClick: null,
  NumberClassName: 'NumberItemPagination',
  page: null,
  icon: null
};
AtomItemPagination.PropTypes = {
  icon: PropTypes.node
};
export default function AtomItemPagination(props) {
  return (
    <div className={props.className} onClick={props.onClick}>
      <span className={props.NumberClassName}>
        {props.icon != null ? props.icon : props.page}
      </span>
    </div>
  );
}
